import { createContext } from 'react';

const MultiLocationContext = createContext({});

export default MultiLocationContext;
